module.exports = "/images/wave-content.svg?4c5b93a566e204fc1184fa4ce0b6b6ad";